import React,{useState, useEffect} from 'react'
import ImageGallery from 'react-image-gallery';

const Gallery = (props)  => {

  const [large, setLarge] = useState(false );

  const handleGalleryToggle = () => {
    setLarge(!large);
  };

  return(
    <div className={large ? "gallery-wrap gallery-wrap--large" : "gallery-wrap"}>
      <div className="gallery-content">
        <ImageGallery lazyLoad={false} showFullscreenButton={true} useBrowserFullscreen={false} showPlayButton={false} items={props.images} />
          {/*<button className="gallery-toggle" aria-label="Enlarge Gallery" onClick={handleGalleryToggle}>
            {large ?
            <svg id="icon-cross" viewBox="0 0 28.864 28.864">
              <path
                d="M15.855 14.431l5.5-5.5a1.007 1.007 0 0 0-1.426-1.42l-5.5 5.5-5.5-5.5a1.006 1.006 0 0 0-1.413 1.423l5.5 5.5-5.5 5.5a1.007 1.007 0 1 0 1.423 1.424l5.5-5.5 5.256 5.258.234.234a1.007 1.007 0 0 0 1.424-1.424z"></path>
            </svg>:
              <svg className="image-gallery-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                   stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path
                  d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3"></path>
              </svg>}
            {large ? 'Zavřít' : ''}
          </button>*/}
          </div>
    </div>

  )
}

export default Gallery;




// WEBPACK FOOTER //
// ./fe/web-prefa/src/js/components/gallery/react/index.js